import { usePathname } from 'next/navigation'

const useIsAppEligibilityPage = () => {
  const pathName = usePathname()
  return pathName === '/app-eligibility' || pathName === '/app-eligibility/'
}

export default useIsAppEligibilityPage
